import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';
import { AuthService } from '../services/auth.service';
import { filter, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AutoLoginGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(): Observable<boolean> {

    return this.authService.isAuthenticated.pipe(
      filter((val) => val !== null),
      take(1),
      map((isAuthenticated) => {

        //console.log(!isAuthenticated);
        //console.log(this.router.url !== '/');
        //console.log(this.router.url !== '/login');
        //console.log(this.router);

        /*
        if (!isAuthenticated) {
          return false;
          //this.router.navigateByUrl('home/buecherei', { replaceUrl: true });
        } else {
          return true;
        }
        */

        return true;
      })
    );
  }
}
